import { render, staticRenderFns } from "./Anli.vue?vue&type=template&id=a944ed36&scoped=true&"
import script from "./Anli.vue?vue&type=script&lang=js&"
export * from "./Anli.vue?vue&type=script&lang=js&"
import style0 from "./Anli.vue?vue&type=style&index=0&id=a944ed36&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a944ed36",
  null
  
)

export default component.exports